// extracted by mini-css-extract-plugin
export default {"label":"Label_label__r9F3o","checked":"Label_checked__cVd9V","icon":"Label_icon__8gHlQ"};